<template>
    <div>
        <v-toolbar dense dark color="secondary" class="white--text">
            <v-spacer></v-spacer>
            <v-toolbar-title>
                New Tracking
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
    </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/mg-api-js"></script>
<script>
// Imports here

export default {
    props: [],
    components: {

    },
    data: function () {
        return {
            geotabApi: null,
            //variables: [],
            //here: true,
            //...
        }
    },
    mounted() {
        //this.functionsForMountedHere();
        //this.init();
    },
    methods: {
        init: function () {
            console.log("Iniciando NewTracking...");
            const authentication = {
                credentials: {
                    database: 'upt',
                    userName: 'email@upt.ca',
                    password: '1234'
                },
                path: 'my.geotab.com'
            }

            const GeotabApi = require('mg-api-js');
            this.geotabApi = new GeotabApi(authentication);
            this.geotabApi.authenticate( success => {
                console.log('Successful authentication');
            }, (message, error) => {
                console.log('Something went wrong');
            });

            //this.getTripsByTruck('b146'); 
        },
        getTripsByTruck: function(TruckGeotabId) {
            console.log("getTripsByTruck");
        },
        /*functionHere: function() {

        },
        otherFunctionHere: function() {

        }
        */
    },
};
</script>

<style>
/* Styles here */
</style>